const focusItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20split%20composition%20of%20two%20figures%20walking%20away%20from%20each%20other%20on%20a%20rainy%20city%20street%2C%20cinematic%20lighting%20with%20warm%20street%20lamps%20and%20cool%20shadows%2C%20emotional%20divorce%20narrative%2C%20editorial%20photography%20style%2C%20clean%20composition&width=1000&height=700&seq=focus-gossip-01&orientation=landscape',
    tag: '年度专题',
    title: '年度最大瓜：某明星夫妻离婚内幕全解析',
    desc: '从甜蜜恩爱到对簿公堂，完整还原这对昔日模范夫妻从恩爱到决裂的全过程。历时三个月追踪，汇集多方信源，为你呈现最完整的离婚内幕与财产分割细节。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Television%20studio%20control%20room%20with%20multiple%20monitors%20showing%20different%20angles%2C%20complex%20production%20setup%2C%20warm%20glowing%20screens%2C%20investigative%20documentary%20aesthetic%2C%20clean%20editorial%20composition&width=1000&height=700&seq=focus-gossip-02&orientation=landscape',
    tag: '深度追踪',
    title: '深度追踪：某综艺造假风波始末',
    desc: '一档备受关注的选秀综艺被指存在严重造假行为，从选手背景虚假到投票数据异常，我们逐帧拆解了节目中的可疑之处，并独家采访了多位退赛选手。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Timeline%20infographic%20wall%20with%20interconnected%20events%20and%20dramatic%20milestones%2C%20warm%20amber%20and%20crimson%20color%20palette%2C%20modern%20data%20visualization%20design%2C%20clean%20editorial%20layout%20with%20chronological%20flow&width=1000&height=700&seq=focus-gossip-03&orientation=landscape',
    tag: '独家整理',
    title: '独家整理：娱乐圈最全塌房时间线',
    desc: '从顶流艺人的税务风波到当红小生的私德争议，我们整理了近三年来娱乐圈最轰动的塌房事件时间线，用数据还原娱乐圈的真实生态变迁。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Single%20spotlight%20illuminating%20an%20empty%20stage%20with%20falling%20confetti%2C%20dramatic%20theater%20atmosphere%2C%20warm%20golden%20light%20beam%2C%20symbolic%20rise%20and%20fall%20narrative%2C%20editorial%20photography%20style%2C%20clean%20composition&width=1000&height=700&seq=focus-gossip-04&orientation=landscape',
    tag: '焦点人物',
    title: '焦点人物：从走红到崩塌的180天',
    desc: '一位凭借选秀一夜爆红的新星，如何在短短半年内从万众瞩目沦为众矢之的。我们追踪其所有公开活动和社交媒体动态，拼凑出完整的人生急转直下轨迹。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Digital%20dashboard%20displaying%20controversial%20events%20as%20visual%20data%20points%2C%20heatmap%20style%20with%20warm%20intense%20colors%2C%20modern%20analytics%20aesthetic%2C%20editorial%20layout%20design%2C%20clean%20composition&width=1000&height=700&seq=focus-gossip-05&orientation=landscape',
    tag: '月度盘点',
    title: '话题热榜：本月最具争议十大事件',
    desc: '回顾过去一个月娱乐圈最具话题性的十大争议事件，从绯闻曝光到法律纠纷，从综艺翻车到品牌解约，为你梳理本月吃瓜必读内容，一网打尽所有精彩瞬间。',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">焦点追踪</h2>
          <p className="text-sm text-foreground-500">深度专题报道，全方位解析重大吃瓜事件</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {focusItems.slice(0, 2).map((item, i) => (
            <article key={i} className={`bg-background-50 rounded-lg overflow-hidden transition-all duration-200 hover:scale-[1.01] cursor-pointer group ${i === 0 ? 'lg:col-span-2' : ''}`}>
              <div className={`relative overflow-hidden bg-background-200 ${i === 0 ? 'aspect-[2/1]' : 'aspect-[4/3]'}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-4 left-4 px-3 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-lg font-semibold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mt-5">
          {focusItems.slice(2).map((item, i) => (
            <article key={i + 2} className="bg-background-50 rounded-lg overflow-hidden transition-all duration-200 hover:scale-[1.01] cursor-pointer group">
              <div className="relative aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 leading-snug line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}